import { FAQConstants } from '../constants';


export function faqs(state = {loadingFaqs:false}, action) {
	switch (action.type) {
		case FAQConstants.GETFAQ_SUCCESS:
			return {
				...state,
				faqs: action.faqs,
				loadingFaqs:false
			};
		case FAQConstants.GETFAQ_FAILURE:
			return {
				...state,
				faqs: [],
				loadingFaqs:false
			};
		case FAQConstants.GETFAQ_REQUEST:
			return {
				...state,
				loadingFaqs:true
			};
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/store/reducers/faqs.reducer.js